import { CountryEnum as m } from "./country-enum.mjs";
import a from "../../_virtual/index.mjs";
import * as e from "../../node_modules/i18n-iso-countries/langs/ar.json.mjs";
import * as f from "../../node_modules/i18n-iso-countries/langs/cs.json.mjs";
import * as p from "../../node_modules/i18n-iso-countries/langs/da.json.mjs";
import * as n from "../../node_modules/i18n-iso-countries/langs/de.json.mjs";
import * as c from "../../node_modules/i18n-iso-countries/langs/el.json.mjs";
import * as l from "../../node_modules/i18n-iso-countries/langs/en.json.mjs";
import * as u from "../../node_modules/i18n-iso-countries/langs/es.json.mjs";
import * as g from "../../node_modules/i18n-iso-countries/langs/fr.json.mjs";
import * as d from "../../node_modules/i18n-iso-countries/langs/hi.json.mjs";
import * as N from "../../node_modules/i18n-iso-countries/langs/hu.json.mjs";
import * as y from "../../node_modules/i18n-iso-countries/langs/id.json.mjs";
import * as C from "../../node_modules/i18n-iso-countries/langs/it.json.mjs";
import * as h from "../../node_modules/i18n-iso-countries/langs/ja.json.mjs";
import * as I from "../../node_modules/i18n-iso-countries/langs/nl.json.mjs";
import * as L from "../../node_modules/i18n-iso-countries/langs/no.json.mjs";
import * as E from "../../node_modules/i18n-iso-countries/langs/pl.json.mjs";
import * as S from "../../node_modules/i18n-iso-countries/langs/pt.json.mjs";
import * as v from "../../node_modules/i18n-iso-countries/langs/ro.json.mjs";
import * as A from "../../node_modules/i18n-iso-countries/langs/ru.json.mjs";
import * as j from "../../node_modules/i18n-iso-countries/langs/sk.json.mjs";
import * as w from "../../node_modules/i18n-iso-countries/langs/sl.json.mjs";
import * as D from "../../node_modules/i18n-iso-countries/langs/sq.json.mjs";
import * as b from "../../node_modules/i18n-iso-countries/langs/sr.json.mjs";
import * as G from "../../node_modules/i18n-iso-countries/langs/sv.json.mjs";
import * as H from "../../node_modules/i18n-iso-countries/langs/th.json.mjs";
import * as O from "../../node_modules/i18n-iso-countries/langs/tr.json.mjs";
import * as R from "../../node_modules/i18n-iso-countries/langs/uk.json.mjs";
import * as _ from "../../node_modules/i18n-iso-countries/langs/zh.json.mjs";
import { LocaleEnum as s } from "../../libs/types/dist/index11.mjs";
import { getLanguageCodeByLocale as q } from "../locales/language-utils.mjs";
const x = {
  ar: e,
  cs: f,
  da: p,
  de: n,
  el: c,
  en: l,
  es: u,
  fr: g,
  hi: d,
  hu: N,
  id: y,
  it: C,
  ja: h,
  nl: I,
  no: L,
  pl: E,
  pt: S,
  ro: v,
  ru: A,
  sk: j,
  sl: w,
  sq: D,
  sr: b,
  sv: G,
  th: H,
  tr: O,
  uk: R,
  zh: _
};
Object.values(x).forEach((r) => {
  a.registerLocale(r.default);
});
const z = (r, o) => {
  try {
    return new Intl.DisplayNames([r], { type: "region" }).of(o);
  } catch {
    return;
  }
}, B = "Canary Islands", i = (r, o) => {
  const t = q(o);
  switch (r) {
    // Related SC https://app.shortcut.com/systeme/story/15639/change-the-name-of-taiwan-province-of-china-to-taiwan
    case m.Taiwan:
      return a.getName(r, t, { select: "alias" });
    case m.CanaryIslands:
      return z(t, r) ?? B;
    default:
      return a.getName(r, t, { select: "official" });
  }
}, Y = (r = s.ENGLISH) => Object.values(m).map((o) => ({
  id: o,
  caption: i(o, r) ?? ""
})), J = (r, o = s.ENGLISH) => i(r, o) ?? "";
export {
  Y as getCountryData,
  J as getSingleCountry
};
